import { render, staticRenderFns } from "./LegalWarningSection.vue?vue&type=template&id=1232369e&scoped=true&"
import script from "./LegalWarningSection.vue?vue&type=script&lang=js&"
export * from "./LegalWarningSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1232369e",
  null
  
)

export default component.exports